<div class="main"><breadcrumb></breadcrumb><div class="div">这是详情页，主要用来展示面包屑</div><div class="pointer" @click="handleClick">点击进入三级页面</div></div>